import { sendCPCLog } from "../../utils/common";

export default class FloatingBanner {
  constructor() {
    if (
      !TMON.oApp.htStorage.intergratedDeals ||
      !TMON.oApp.htStorage.intergratedDeals.data ||
      !TMON.oApp.htStorage.intergratedDeals.data.FLOATING_DEALS ||
      !TMON.oApp.htStorage.intergratedDeals.data.FLOATING_DEALS.length
    ) {
      return;
    }
    this.render();
    this.setEvent();
  } 

  render() {
    const { FLOATING_DEALS } = TMON.oApp.htStorage.intergratedDeals.data;
    const { imageInfo, titleName } = FLOATING_DEALS[0];
    const sHtml = `<div class="floating-banner" style="left: -300px; transition: left 0.5s ease-in-out;">
      <a href=${this.getUrl(FLOATING_DEALS[0])} tl:area="DCFB">
        <img src=${imageInfo.mobile3ColImageUrl} alt=${titleName}>
        <div class="floating-banner__text">
          <p class="suggest"><strong>이 상품은 어때요?</strong><i class="adv">AD</i></p>
          <p>다른 고객이 많이 본 상품이에요!</p>
        </div>
      </a>
      <button type="button" class="floating-banner__close" tl:area="DCFBC">
        <span class="hide">닫기</span>
      </button>
    </div>`;
    $('#ct').append(sHtml);

    setTimeout(() => {
      $('.floating-banner').css('left', '0px');
      sendCPCLog([{ href: this.getUrl(FLOATING_DEALS[0]) }], 'IMPRESSION');
    }, 100);
  }

  setEvent() {
    const { FLOATING_DEALS } = TMON.oApp.htStorage.intergratedDeals.data;

    $('.floating-banner').on('click', () => {
      sendCPCLog([{ href: this.getUrl(FLOATING_DEALS[0]) }], 'CLICK');
    });

    $('.floating-banner__close').on('click', (e) => {
      e.stopPropagation();
      setTimeout(() => {
        $('.floating-banner').css('left', '-300px');
      }, 100);
    });
  }

  getUrl(item) {
    return TMON.util.aup(
      `${item.admonClickUrl}&fwUrl=${encodeURIComponent(
        TMON.util.aup(
          `${TMON.htLocal.htURL.www_m_deals}${item.dealNo}`,
          TMON.sAppQuery
        )
      )}`,
      TMON.sAppQuery
    );
  }
}